module.exports = __webpack_public_path__ + "static/media/Louise_Fresco_desktop.2ac7fe11.jpg";